import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout: gives the endpoint page a "Webhooks" crumb and guards both screens. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/webhooks')({
  staticData: { crumb: 'common:nav.webhooks' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'webhooks.manage');
  },
  component: Outlet,
});
